export interface MCQ {
  question: string;
  answer: string;
  fakeAnswers: string[];
}

export const SCHOOL_QUESTIONS: MCQ[] = [
  {
    question: "What's the main purpose of a checking account?",
    answer: 'Everyday transactions',
    fakeAnswers: [
      'Long-term savings',
      'Investing in stocks',
      'Paying off loans',
    ],
  },
  {
    question: 'Which type of account typically earns more interest?',
    answer: 'Savings account',
    fakeAnswers: ['Checking account', 'Retirement account', 'Bonds'],
  },
  {
    question: 'What does the term "bull market" refer to?',
    answer: 'A market with increasing stock prices',
    fakeAnswers: [
      'A market with declining stock prices',
      'A market for selling bonds',
      'A market for buying livestock',
    ],
  },
  {
    question:
      'What is a potential benefit of working part-time while attending school?',
    answer: 'Gaining work experience',
    fakeAnswers: [
      'Increased leisure time',
      'Guaranteed job after graduation',
      'Lower tuition fees',
    ],
  },
  {
    question:
      'Which option might provide a better work-life balance during school years?',
    answer: 'Working part-time',
    fakeAnswers: [
      'Working overtime',
      'Not working at all',
      'Working full-time',
    ],
  },
  {
    question:
      'What is the importance of having a diversified investment portfolio?',
    answer: 'Reducing risk',
    fakeAnswers: [
      'Increasing bank fees',
      'Focusing on one industry',
      'Avoiding taxes',
    ],
  },
  {
    question:
      'What could be a financial benefit of working part-time during school?',
    answer: 'Earning money to cover living expenses',
    fakeAnswers: [
      'Increasing student loan debt',
      'Lowering tuition costs',
      'Having more time for extracurricular activities',
    ],
  },
  {
    question:
      'What could be a financial benefit of working part-time during school?',
    answer: 'Learning better time management',
    fakeAnswers: [
      'Guaranteed job after graduation',
      'Lowering tuition costs',
      'More stress',
    ],
  },
  {
    question:
      'If you save $200 every month, how much will you have saved after 2 years?',
    answer: '$4,800',
    fakeAnswers: ['$6,000', '$1,200', '$2,400'],
  },
  {
    question: 'What is compound interest?',
    answer:
      'Interest earned on both the initial amount and any interest already earned',
    fakeAnswers: [
      'Interest on loans only',
      'Interest on credit cards only',
      'Interest on mortgages only',
    ],
  },
  {
    question:
      'Which of the following is a common reason to open a savings account?',
    answer: 'To save for short-term or long-term goals',
    fakeAnswers: [
      'To pay off loans faster',
      'To invest in the stock market',
      'To pay daily expenses',
    ],
  },
  {
    question:
      'Why might someone choose to invest in a low-risk, low-return investment?',
    answer: 'To protect their capital',
    fakeAnswers: [
      'To take on a lot of debt',
      'To speculate on market trends',
      'To get rich quickly',
    ],
  },
  {
    question:
      'If you invest $1,000 in a stock and its value increases by 11%, how much is your investment worth now?',
    answer: '$1,110',
    fakeAnswers: ['$1,010', '$900', '$1,200'],
  },
  {
    question: "What's a common feature of both checking and savings accounts?",
    answer: 'They both are insured by the FDIC',
    fakeAnswers: [
      'They both are used for investing in stocks',
      'They both have high interest rates',
      'They both provide loans',
    ],
  },
  {
    question: 'When might be a good time to start investing in stocks?',
    answer: 'When you have a solid emergency fund',
    fakeAnswers: [
      'When you have no savings',
      'When you have no income',
      'When you have a lot of credit card debt',
    ],
  },
  {
    question:
      'You invest $1,000 in a stock. The stock price increases by 5% the first year, then decreases by 3% the next year. What is the value of your investment after two years?',
    answer: '$1,018.50',
    fakeAnswers: ['$1,022.50', '$1,020', '$1,015'],
  },
  {
    question: 'What is one of the main purposes of a budget?',
    answer: 'To track income and expenses',
    fakeAnswers: [
      'To open multiple bank accounts',
      'To invest in stocks',
      'To spend without restrictions',
    ],
  },
  {
    question:
      'What is the term for the fee charged by a bank for overdrawing your account?',
    answer: 'Overdraft fee',
    fakeAnswers: ['Transaction fee', 'Interest fee', 'Maintenance fee'],
  },
];

export const WORK_QUESTIONS1: MCQ[] = [
  {
    question:
      'If you deposit $500 in a savings account with an annual interest rate of 2%, how much will you have after one year?',
    answer: '$510',
    fakeAnswers: ['$530', '$600', '$520'],
  },
  {
    question:
      'If you buy 10 shares of a stock at $20 each and sell them when the price reaches $30, what is your total profit?',
    answer: '$100',
    fakeAnswers: ['$200', '$300', '$400'],
  },
  {
    question: 'What does the term "bull market" refer to?',
    answer: 'A market with increasing stock prices',
    fakeAnswers: [
      'A market with declining stock prices',
      'A market for selling bonds',
      'A market for buying livestock',
    ],
  },
  {
    question: "What's a common feature of both checking and savings accounts?",
    answer: 'They both are insured by the FDIC',
    fakeAnswers: [
      'They both are used for investing in stocks',
      'They both have high interest rates',
      'They both provide loans',
    ],
  },
  {
    question:
      'If you withdraw $200 from your checking account twice a month, how much will you have withdrawn over the course of a year?',
    answer: '$4,800',
    fakeAnswers: ['$2,400', '$480', '$1,200'],
  },
  {
    question:
      'You purchase 50 shares of a company at $20 per share. If the share price rises to $30, what is your current total profit of your shares?',
    answer: '$500',
    fakeAnswers: ['$1,500', '$750', '$2,500'],
  },
  {
    question:
      'What is the annual interest rate if the interest earned on a $1,000 savings account after one year is $25?',
    answer: '0.25%',
    fakeAnswers: ['2.5%', '25%', '5%'],
  },
  {
    question:
      'You work part-time during school and earn $500 per month. If you save 50% of your earnings, how much will you have saved after a year?',
    answer: '$3,000',
    fakeAnswers: ['$6,000', '$2,500', '$1,500'],
  },
  {
    question:
      'What is the term for the fee charged by a bank for overdrawing your account?',
    answer: 'Overdraft fee',
    fakeAnswers: ['Transaction fee', 'Interest fee', 'Maintenance fee'],
  },
];

export const WORK_QUESTIONS2: MCQ[] = [
  {
    question:
      'If you work 20 hours per week at $15 per hour, how much will you earn in a month (assuming 4 weeks in a month)?',
    answer: '$1,200',
    fakeAnswers: ['$600', '$1,800', '$2,400'],
  },
  {
    question: 'When might be a good time to start investing in stocks?',
    answer: 'When you have a solid emergency fund',
    fakeAnswers: [
      'When you have no savings',
      'When you have no income',
      'When you have a lot of credit card debt',
    ],
  },
  {
    question:
      'Your bank charges a $10 monthly maintenance fee on your checking account. How much will you be charged in a year?',
    answer: '$120',
    fakeAnswers: ['$110', '$10', '$100'],
  },
  {
    question: "What's a common feature of both checking and savings accounts?",
    answer: 'They both are insured by the FDIC',
    fakeAnswers: [
      'They both are used for investing in stocks',
      'They both have high interest rates',
      'They both provide loans',
    ],
  },
  {
    question:
      'If you deposit $500 in a savings account with a 2% annual interest rate, how much will you have after 3 years?',
    answer: '$530.60',
    fakeAnswers: ['$530.40', '$530', '$540'],
  },
  {
    question:
      'You invest $2,000 in a bond that pays an annual interest rate of 5%. How much interest will you earn over 3 years?',
    answer: '$300',
    fakeAnswers: ['$600', '$100', '$900'],
  },
  {
    question: 'What is the break-even point formula in a business context?',
    answer: 'Fixed Costs / (Price - Variable Costs)',
    fakeAnswers: [
      ' Variable Costs / (Price - Fixed Costs)',
      'Price / (Fixed Costs - Variable Costs)',
      '(Price - Variable Costs) / Fixed Costs',
    ],
  },
  {
    question:
      'Why might someone choose to invest in a low-risk, low-return investment?',
    answer: 'To protect their capital',
    fakeAnswers: [
      'To take on a lot of debt',
      'To speculate on market trends',
      'To get rich quickly',
    ],
  },
  {
    question: "What's the main purpose of a checking account?",
    answer: 'Everyday transactions',
    fakeAnswers: [
      'Long-term savings',
      'Investing in stocks',
      'Paying off loans',
    ],
  },
  {
    question:
      'You purchase 50 shares of a company at $20 per share. If the share price rises to $30, what is your current total profit of your shares?',
    answer: '$500',
    fakeAnswers: ['$1,500', '$750', '$2,500'],
  },
  {
    question:
      'A stock you own pays a $2 dividend per share quarterly. If you own 50 shares, how much will you receive in dividends in a year?',
    answer: '$400',
    fakeAnswers: ['$100', '$200', '$1,200'],
  },
  {
    question:
      'You bought a stock at $50 per share and sold it for $30 per share. You owned 10 shares. What is your net loss?',
    answer: '$200',
    fakeAnswers: ['$100', '$300', '$2000'],
  },
];
